import Api from '../../../../shared/Api';

class SEPlayApi {
    static getPhotoStatus(orderId: number): Promise<string> {
        return new Api().get(`/views/orders/${orderId}/imageprocessing/photostatus`);
    }
    static getImageReference(orderId: number): Promise<string> {
        return new Api().get(`/views/orders/${orderId}/imageprocessing/getimagegalleryreference`);
    }
    static getOrderImages(orderId: number, reference: string): Promise<string> {
        return new Api().get(
            `/views/orders/${orderId}/imageprocessing/get-slideshow-images/${reference}`
        );
    }

    static updateImage(orderId, imageReference, imageList) {
        return new Api().put(
            `/views/orders/${orderId}/imageprocessing/update-slideshow-image/${imageReference}`,
            {
                imageData: {
                    imageList
                }
            }
        );
    }
}
export default SEPlayApi;
